import { getProductTokens } from '@sirius-cybernetics-42/product-config'

import { ChainId, Token } from '../../sdk'

function toProductToken(chainId: ChainId, symbol: string) {
  const product = getProductTokens(chainId).find((entry) => entry.symbol === symbol)
  if (!product) {
    throw new Error(`Missing product token ${symbol} for chain ${chainId}`)
  }
  return product
}

/**
 * Infinite Mainnet — constantes de referencia (tests, LP watch).
 * Direcciones desde `@sirius-cybernetics-42/product-config`.
 */
/** Mismo contrato que Nutrimatic `PANIC` / `evm:421018:instrument:panic` (renombre de símbolo). */
const panicProduct = toProductToken(ChainId.INFINITE_MAINNET, 'PANIC')

export const PANIC = new Token(
  ChainId.INFINITE_MAINNET,
  panicProduct.address,
  panicProduct.decimals,
  panicProduct.symbol,
  panicProduct.name,
)

/** @deprecated Prefer `PANIC` — alias histórico del mismo token. */
export const DONT = PANIC
